<habil-grupo>
<div class="us">
    <nav class="us-trilha" aria-label="Nível do painel">
        <button type="button" class="us-trilha-item" [class.ativo]="nivel === 'geral'" (click)="irParaGeral()">
            <i class="pi pi-globe"></i> Todos os clientes
        </button>
        <ng-container *ngIf="cnpj">
            <i class="pi pi-angle-right us-trilha-sep"></i>
            <button type="button" class="us-trilha-item" [class.ativo]="nivel === 'cliente'" (click)="irParaCliente()">
                <i class="pi pi-building"></i> {{ nomeCliente || documento(cnpj) }}
            </button>
        </ng-container>
        <ng-container *ngIf="idUsuario !== null">
            <i class="pi pi-angle-right us-trilha-sep"></i>
            <span class="us-trilha-item ativo"><i class="pi pi-user"></i> {{ nomeUsuario }}</span>
        </ng-container>
    </nav>

    <div class="p-fluid p-grid">
        <div class="p-col-12 p-md-3">
            <habil-label name="usPeriodo" label="Período">
                <p-dropdown [options]="periodos" [(ngModel)]="periodo" (onChange)="aplicaPeriodo()" appendTo="body"></p-dropdown>
            </habil-label>
        </div>
        <div class="p-col-6 p-md-3">
            <habil-label name="usInicio" label="Data Inicial">
                <input type="date" pInputText [(ngModel)]="inicio" (ngModelChange)="mudouData()">
            </habil-label>
        </div>
        <div class="p-col-6 p-md-3">
            <habil-label name="usFim" label="Data Final">
                <input type="date" pInputText [(ngModel)]="fim" (ngModelChange)="mudouData()">
            </habil-label>
        </div>
        <div class="p-col-12 p-md-3 p-col-align-end">
            <p-button label="Buscar" icon="pi pi-search" [disabled]="carregando" (onClick)="carregar()"></p-button>
        </div>
    </div>

    <div class="p-fluid p-grid" *ngIf="nivel !== 'geral' && opcoesEmpresa.length > 1">
        <div class="p-col-12 p-md-6">
            <habil-label name="usEmpresa" label="Empresa">
                <p-dropdown [options]="opcoesEmpresa" [(ngModel)]="empresa" (onChange)="carregar()"
                    [filter]="opcoesEmpresa.length > 8" filterBy="label" appendTo="body"></p-dropdown>
            </habil-label>
        </div>
    </div>

    <div *ngIf="erro" class="p-error us-erro">{{ erro }}</div>
    <p-progressBar *ngIf="carregando" mode="indeterminate" [style]="{ height: '4px' }"></p-progressBar>

    <ng-container *ngIf="painel as p">
        <div class="us-indicadores">
            <div class="us-indicador" *ngIf="nivel === 'geral'">
                <span class="us-rotulo">Clientes ativos</span>
                <strong>{{ p.totais.empresas | number }}</strong>
                <small>com uso no período</small>
            </div>
            <div class="us-indicador" *ngIf="nivel !== 'usuario'">
                <span class="us-rotulo">Usuários ativos</span>
                <strong>{{ p.totais.usuarios | number }}</strong>
                <small>fizeram login no período</small>
            </div>
            <div class="us-indicador" *ngIf="nivel === 'usuario'">
                <span class="us-rotulo">Dias com uso</span>
                <strong>{{ p.totais.diasComUso | number }}</strong>
                <small>de {{ diasPeriodo | number }} no período</small>
            </div>
            <div class="us-indicador">
                <span class="us-rotulo">Logins</span>
                <strong>{{ p.totais.logins | number }}</strong>
                <small>{{ p.totais.loginsPdv | number }} no PDV</small>
            </div>
            <div class="us-indicador">
                <span class="us-rotulo">Tempo em rotinas</span>
                <strong>{{ duracao(p.totais.tempo) }}</strong>
                <small>{{ duracao(tempoMedio) }} por usuário/dia</small>
            </div>
            <div class="us-indicador">
                <span class="us-rotulo">Entradas em rotinas</span>
                <strong>{{ p.totais.entradas | number }}</strong>
                <small>{{ p.totais.rotinas | number }} rotinas diferentes</small>
            </div>
            <div class="us-indicador">
                <span class="us-rotulo">Haila (IA)</span>
                <strong>{{ p.totais.iaChamadas | number }}</strong>
                <small>{{ (p.totais.iaTokensEntrada + p.totais.iaTokensSaida) | number }} tokens</small>
            </div>
        </div>

        <div *ngIf="!p.dias.length && !carregando" class="us-vazio">
            Nenhum uso recebido nesse período.
        </div>

        <div class="us-graficos" *ngIf="p.dias.length">
            <section class="us-cartao us-largo">
                <h3>Atividade por dia</h3>
                <p-chart type="bar" [data]="graficoDiario.dados" [options]="graficoDiario.opcoes" height="280px"></p-chart>
            </section>

            <section class="us-cartao" *ngIf="p.rotinas.length">
                <h3>Rotinas com mais tempo</h3>
                <p-chart type="bar" [data]="graficoRotinas.dados" [options]="graficoRotinas.opcoes" height="300px"></p-chart>
                <small class="us-apagado"><span class="us-ponto us-ponto-funcao"></span> Função <span class="us-ponto us-ponto-relatorio"></span> Relatório</small>
            </section>

            <section class="us-cartao" *ngIf="p.categorias.length">
                <h3>Tempo por tipo de rotina</h3>
                <p-chart type="doughnut" [data]="graficoCategorias.dados" [options]="graficoCategorias.opcoes" height="300px"></p-chart>
            </section>

            <section class="us-cartao">
                <h3>{{ nivel === 'usuario' ? 'Horas por dia da semana' : 'Usuários ativos por dia da semana' }}</h3>
                <p-chart type="bar" [data]="graficoSemana.dados" [options]="graficoSemana.opcoes" height="260px"></p-chart>
                <small class="us-apagado">Média no período.</small>
            </section>

            <section class="us-cartao" *ngIf="graficoOrigens">
                <h3>Clientes por plataforma</h3>
                <p-chart type="doughnut" [data]="graficoOrigens.dados" [options]="graficoOrigens.opcoes" height="260px"></p-chart>
            </section>

            <section class="us-cartao" *ngIf="graficoIa">
                <h3>Uso da Haila por dia</h3>
                <p-chart type="line" [data]="graficoIa.dados" [options]="graficoIa.opcoes" height="260px"></p-chart>
            </section>
        </div>

        <section class="us-cartao us-tabela" *ngIf="nivel === 'geral' && p.clientes.length">
            <div class="us-tabela-topo">
                <h3>Clientes <small class="us-apagado">clique para ver os usuários</small></h3>
                <input type="text" pInputText placeholder="Nome ou CNPJ" [(ngModel)]="buscaLista" (ngModelChange)="filtrarLista()">
            </div>
            <p-table [value]="clientes" [paginator]="clientes.length > 25" [rows]="25" [rowsPerPageOptions]="[25, 50, 100]"
                sortField="tempo" [sortOrder]="-1" selectionMode="single" (onRowSelect)="abrirCliente($event.data)"
                responsiveLayout="scroll" styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines">
                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="nome">Cliente <p-sortIcon field="nome"></p-sortIcon></th>
                        <th pSortableColumn="origem">Plataforma <p-sortIcon field="origem"></p-sortIcon></th>
                        <th pSortableColumn="empresas" class="us-num">Empresas <p-sortIcon field="empresas"></p-sortIcon></th>
                        <th pSortableColumn="usuarios" class="us-num">Usuários <p-sortIcon field="usuarios"></p-sortIcon></th>
                        <th pSortableColumn="diasComUso" class="us-num">Dias <p-sortIcon field="diasComUso"></p-sortIcon></th>
                        <th pSortableColumn="logins" class="us-num">Logins <p-sortIcon field="logins"></p-sortIcon></th>
                        <th pSortableColumn="entradas" class="us-num">Entradas <p-sortIcon field="entradas"></p-sortIcon></th>
                        <th pSortableColumn="tempo" class="us-num">Tempo <p-sortIcon field="tempo"></p-sortIcon></th>
                        <th pSortableColumn="iaChamadas" class="us-num">Haila <p-sortIcon field="iaChamadas"></p-sortIcon></th>
                        <th pSortableColumn="ultimoAcesso">Último acesso <p-sortIcon field="ultimoAcesso"></p-sortIcon></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-c>
                    <tr [pSelectableRow]="c">
                        <td>
                            <div class="us-nome">{{ c.nome || 'Sem cadastro na Central' }}</div>
                            <small class="us-apagado">{{ documento(c.cnpj) }}</small>
                        </td>
                        <td>{{ c.origem }}</td>
                        <td class="us-num">{{ c.empresas | number }}</td>
                        <td class="us-num">{{ c.usuarios | number }}</td>
                        <td class="us-num">{{ c.diasComUso | number }}</td>
                        <td class="us-num">{{ c.logins | number }}</td>
                        <td class="us-num">{{ c.entradas | number }}</td>
                        <td class="us-num">{{ duracao(c.tempo) }}</td>
                        <td class="us-num">{{ c.iaChamadas | number }}</td>
                        <td>{{ c.ultimoAcesso | date: 'dd/MM/yyyy HH:mm' }}</td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr><td colspan="10">Nenhum cliente encontrado.</td></tr>
                </ng-template>
            </p-table>
        </section>

        <section class="us-cartao us-tabela" *ngIf="nivel === 'cliente' && p.usuarios.length">
            <div class="us-tabela-topo">
                <h3>Usuários <small class="us-apagado">clique para ver o uso do usuário</small></h3>
                <input type="text" pInputText placeholder="Nome do usuário" [(ngModel)]="buscaLista" (ngModelChange)="filtrarLista()">
            </div>
            <p-table [value]="usuarios" [paginator]="usuarios.length > 25" [rows]="25" [rowsPerPageOptions]="[25, 50, 100]"
                sortField="tempo" [sortOrder]="-1" selectionMode="single" (onRowSelect)="abrirUsuario($event.data)"
                responsiveLayout="scroll" styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines">
                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="nome">Usuário <p-sortIcon field="nome"></p-sortIcon></th>
                        <th pSortableColumn="diasComUso" class="us-num">Dias <p-sortIcon field="diasComUso"></p-sortIcon></th>
                        <th pSortableColumn="logins" class="us-num">Logins <p-sortIcon field="logins"></p-sortIcon></th>
                        <th pSortableColumn="entradas" class="us-num">Entradas <p-sortIcon field="entradas"></p-sortIcon></th>
                        <th pSortableColumn="tempo" class="us-num">Tempo <p-sortIcon field="tempo"></p-sortIcon></th>
                        <th pSortableColumn="rotinas" class="us-num">Rotinas <p-sortIcon field="rotinas"></p-sortIcon></th>
                        <th pSortableColumn="iaChamadas" class="us-num">Haila <p-sortIcon field="iaChamadas"></p-sortIcon></th>
                        <th pSortableColumn="ultimoAcesso">Último acesso <p-sortIcon field="ultimoAcesso"></p-sortIcon></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-u>
                    <tr [pSelectableRow]="u">
                        <td class="us-nome">{{ u.nome || 'Usuário ' + u.idUsuario }}</td>
                        <td class="us-num">{{ u.diasComUso | number }}</td>
                        <td class="us-num">{{ u.logins | number }}<small *ngIf="u.loginsPdv" class="us-apagado"> ({{ u.loginsPdv | number }} PDV)</small></td>
                        <td class="us-num">{{ u.entradas | number }}</td>
                        <td class="us-num">{{ duracao(u.tempo) }}</td>
                        <td class="us-num">{{ u.rotinas | number }}</td>
                        <td class="us-num">{{ u.iaChamadas | number }}</td>
                        <td>{{ u.ultimoAcesso | date: 'dd/MM/yyyy HH:mm' }}</td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr><td colspan="8">Nenhum usuário encontrado.</td></tr>
                </ng-template>
            </p-table>
        </section>

        <section class="us-cartao us-tabela" *ngIf="p.rotinas.length">
            <div class="us-tabela-topo">
                <h3>Rotinas <small class="us-apagado" *ngIf="p.rotinas.length >= 100">as 100 com mais tempo</small></h3>
                <div class="us-tabela-filtros">
                    <p-dropdown [options]="categoriasRotina" [(ngModel)]="categoriaRotina" (onChange)="filtrarRotinas()" appendTo="body"></p-dropdown>
                    <input type="text" pInputText placeholder="Nome da rotina" [(ngModel)]="buscaRotina" (ngModelChange)="filtrarRotinas()">
                </div>
            </div>
            <p-table [value]="rotinas" [paginator]="rotinas.length > 25" [rows]="25" [rowsPerPageOptions]="[25, 50, 100]"
                sortField="tempo" [sortOrder]="-1" responsiveLayout="scroll"
                styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines">
                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="descricao">Rotina <p-sortIcon field="descricao"></p-sortIcon></th>
                        <th pSortableColumn="categoria">Tipo <p-sortIcon field="categoria"></p-sortIcon></th>
                        <th pSortableColumn="entradas" class="us-num">Entradas <p-sortIcon field="entradas"></p-sortIcon></th>
                        <th pSortableColumn="tempo" class="us-num">Tempo <p-sortIcon field="tempo"></p-sortIcon></th>
                        <th pSortableColumn="usuarios" class="us-num" *ngIf="nivel !== 'usuario'">Usuários <p-sortIcon field="usuarios"></p-sortIcon></th>
                        <th pSortableColumn="empresas" class="us-num" *ngIf="nivel === 'geral'">Clientes <p-sortIcon field="empresas"></p-sortIcon></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-r>
                    <tr>
                        <td>{{ r.descricao || r.rotina }}</td>
                        <td>{{ r.categoria }}</td>
                        <td class="us-num">{{ r.entradas | number }}</td>
                        <td class="us-num">{{ duracao(r.tempo) }}</td>
                        <td class="us-num" *ngIf="nivel !== 'usuario'">{{ r.usuarios | number }}</td>
                        <td class="us-num" *ngIf="nivel === 'geral'">{{ r.empresas | number }}</td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr><td colspan="6">Nenhuma rotina encontrada.</td></tr>
                </ng-template>
            </p-table>
        </section>
    </ng-container>
</div>
</habil-grupo>
